export default "<gtd-shell></gtd-shell>\n<div class=\"loading\" *ngIf=\"loading\">\n  <gtd-loading></gtd-loading>\n</div>\n"